
import { defineComponent, PropType } from 'vue'

import OkInput from '@/modules/OktellModule/components/OkInput/index.vue'

export default defineComponent({
    components: {
        OkInput,
    },
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        value: {
            type: [String, null] as PropType<string | null>,
            default: null,
        },
        valueValidation: {
            type: Object,
            default: null,
        },
        min: {
            type: String,
            default: null,
        },
        isTodayDisabled: {
            type: Boolean,
            default: false,
        },
        name: {
            type: String,
            default: 'Укажите дату отправки',
        },
        widthFull: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: null,
        },
        required: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:value', 'change'],
    setup(props, { emit }) {
        const formatDateStringToApi = (dateStr: string | null): string => {
            if (!dateStr) return ''

            const date = new Date(dateStr)

            let day = date.getDate() as string | number
            let month = (date.getMonth() + 1) as string | number

            const year = date.getFullYear()

            if ((day as number) < 10) {
                day = `0${day}`
            }

            if ((month as number) < 10) {
                month = `0${month}`
            }

            return `${day}.${month}.${year}`
        }

        const unformatDateStringFromApi = (dateStr: string | null) => {
            if (!dateStr) return null

            const parts = dateStr.split('.').reverse()
            return parts.join('-')
        }

        const onDateChanged = (date: string | null) => {
            if (props.disabled) return

            emit('update:value', formatDateStringToApi(date))
            emit('change', formatDateStringToApi(date))
        }

        const isDateEquals = (dateOne: Date, dateTwo: Date): boolean => {
            const d1 = new Date(dateOne.getFullYear(), dateOne.getMonth(), dateOne.getDate())
            const d2 = new Date(dateTwo.getFullYear(), dateTwo.getMonth(), dateTwo.getDate())
            return d1.getTime() === d2.getTime()
        }

        const isDateEqualsToday = (): boolean => {
            if (!props.value) return false

            const today = new Date()
            const value = new Date(unformatDateStringFromApi(props.value) as string)

            return isDateEquals(today, value)
        }

        const isDateEqualsTomorrow = (): boolean => {
            if (!props.value) return false

            const today = new Date()
            today.setDate(today.getDate() + 1)

            const value = new Date(unformatDateStringFromApi(props.value) as string)

            return isDateEquals(today, value)
        }

        const isDateEqualsAfterTomorrow = (): boolean => {
            if (!props.value) return false

            const today = new Date()
            today.setDate(today.getDate() + 2)

            const value = new Date(unformatDateStringFromApi(props.value) as string)

            return isDateEquals(today, value)
        }

        const formatDateToValue = (date: Date) => {
            let day = date.getDate() as string | number
            let month = (date.getMonth() + 1) as string | number

            const year = date.getFullYear()

            if ((day as number) < 10) {
                day = `0${day}`
            }

            if ((month as number) < 10) {
                month = `0${month}`
            }

            return `${day}.${month}.${year}`
        }

        const onSelectToday = () => {
            if (props.disabled || props.isTodayDisabled) return

            const today = new Date()
            const value = formatDateToValue(today)

            emit('update:value', value)
            emit('change', value)
        }

        const onSelectTomorrow = () => {
            if (props.disabled) return

            const today = new Date()
            today.setDate(today.getDate() + 1)

            const value = formatDateToValue(today)

            emit('update:value', value)
            emit('change', value)
        }

        const onSelectAfterTomorrow = () => {
            if (props.disabled) return

            const today = new Date()
            today.setDate(today.getDate() + 2)

            const value = formatDateToValue(today)

            emit('update:value', value)
            emit('change', value)
        }

        return {
            unformatDateStringFromApi,
            onDateChanged,
            isDateEqualsToday,
            isDateEqualsTomorrow,
            isDateEqualsAfterTomorrow,
            onSelectToday,
            onSelectTomorrow,
            onSelectAfterTomorrow,
        }
    },
})
